export default "<!-- Vue Component -->\n\n<template>\n  <v-dialog :fullscreen=\"$vuetify.breakpoint.xsOnly\">\n    ...\n  </v-dialog>\n</template>\n";